import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Shared/Loader/Loader";
import { myProfileConstants } from "../../../../constants/MyProfileObjects";
import { utilService } from "../../../../services/utilService";
import MyProfileEdit from "./components/MyProfileEdit/MyProfileEdit";
import {
  profileEditParams,
  RespProfileEditInterface,
} from "./Models/MyProfile.model";
import { MyProfileEditService } from "./MyProfile.service";
import "./MyProfile.scss";
import { useTranslation } from "react-i18next";

interface MyProfileProps {
  onCancel: () => void;
}

const MyProfile: React.FC<MyProfileProps> = (props) => {
  const { t } = useTranslation("settings");
  const [isMyProfileActive, setIsMyProfileActive] = useState(true);
  const [isMyProfileEditActive, setIsMyProfileEditActive] = useState(false);

  const editUserDetails = () => {
    setIsMyProfileActive(false);
    setIsMyProfileEditActive(true);
  };

  const onCancelClick = () => {
    getProfileEditDetailsToDisplay(params);
    setIsMyProfileEditActive(false);
  };

  const [isLoaderActive, setLoaderStatus] = useState(true);
  var [profileEditData, setProfileEditData]: any = useState([]);

  useEffect(() => {
    
    getProfileEditDetailsToDisplay(params);
  }, []);

  async function getProfileEditDetailsToDisplay(params: profileEditParams) {
    
    setLoaderStatus(true);
    const respProfileEditResult: RespProfileEditInterface =
      await MyProfileEditService.getProfileEditDetails(params);
    if (respProfileEditResult.isSuccess) {
      // Extract current_user from new API response structure
      const user = respProfileEditResult?.displayProfileEditContainer?.[0]?.userData;
      if (user) {
        // Set profileEditData with direct profile_pic value in src
        setProfileEditData({
          ...user,
          image: user.profilePic // Use profile_pic directly for src
        });
      } else {
        setProfileEditData({});
      }
    } else {
      MyProfileEditService.handleErrorResponse();
    }
    setLoaderStatus(false);
    setIsMyProfileActive(true);
  }

  const params = {
    guid: utilService.getLoggedUserGuid(),
    reg_code: utilService.getNetwork(),
  };

  return (
    <div>
      {isMyProfileActive
        ? [
            <div className="my-profile-container">
              <div className="profile-back" onClick={props.onCancel}>
                <div className="profile-back-icon icon-back"></div>
              </div>

              <div className="pro-pic">
                <img
                  src={profileEditData?.image}
                  alt="profile pic"
                  className="profile-pic"
                  onError={(
                    e: React.SyntheticEvent<HTMLImageElement, Event>
                  ) => {
                    const target = e.target as HTMLImageElement;
                    target.src = profileEditData?.image
                  }}
                />
              </div>
              <div className="container">
                <div className="container-center">
                  {isLoaderActive && (
                    <div className="loader-container">
                      <Loader></Loader>
                    </div>
                  )}
                  <div className="header">
                    <div
                      className="user-name ellipsis-text"
                      title="{{user.first_name | titlecase }} {{user.last_name  | titlecase }}"
                    >
                      {profileEditData.firstName} {profileEditData.lastName}
                    </div>
                    <div
                      className="img-wrap icon-edit clickable"
                      onClick={() => editUserDetails()}
                    ></div>
                  </div>
                  <div className="my-profile-wrapper">
                    {myProfileConstants.map((item: any) => {
                      return (
                        <div className="my-profile-card-wrapper">
                          <div className="wrapper">
                            <div className="img-wrap-small">
                              <span className={item.icon}></span> {""}
                            </div>
                            <div className="item-label">
                            <span>{t(item.label)}</span>
                            </div>
                          </div>
                          {item.label !== "Group" && item.label !== "Number" ? (
                            <div className="item-value">
                              {profileEditData.email}
                            </div>
                          ) : (
                            <div></div>
                          )}
                          {item.label === "Number" ? (
                            <div className="item-value">
                              {profileEditData.mobileNumber}
                            </div>
                          ) : (
                            <div></div>
                          )}
                          {item.label === "Group" ? (
                            <div className="group-section">
                              <div className="group-scroll">
                                {profileEditData.groups &&
                                profileEditData.groups.length > 0 ? (
                                  profileEditData.groups.map(
                                    (group: any, index: number) => (
                                      <div key={index} className="group-item">
                                        {group}
                                      </div>
                                    )
                                  )
                                ) : (
                                  <div>No Records to display</div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>,
          ]
        : [
            <div>
              {isMyProfileEditActive && (
                <MyProfileEdit onCancel={onCancelClick}></MyProfileEdit>
              )}
            </div>,
          ]}
    </div>
  );
};
export default MyProfile;
